<template>
  <div id="">
    <div class="loading-logo">
      <img src="@/assets/images/logo/logo.png" alt="Logo">
    </div>
    <div class="loading">
      <div class="effect-1 effects"></div>
      <div class="effect-2 effects"></div>
      <div class="effect-3 effects"></div>
    </div>
  </div>
</template>

<script>

import { getErrorMessage } from '@/i18n/util'

export default {
  methods: {
    handleLoginEvent(data) {
      this.$store.dispatch('updateUserInfo', {
        ...data
      })

      let token = data.token
      const editorExtensionId = this.$route.query.extId 
      if (token && editorExtensionId) {
        this.$store.dispatch('auth/loginExt', {token, extId: editorExtensionId})
      }

      this.$router.push(`/?continue=${localStorage.getItem('continueDomain')}&loading=true`)
    }
  },
  created() {
    if (this.$route.query) {
      this.$auth.handleAuthentication(this.$route.fullPath, this.$route.name).then(() => {

      }).catch((err) => {
        this.$router.push(`/?continue=${localStorage.getItem('continueDomain')}`)
        this.$vs.notify({
          title: 'Error',
          text: getErrorMessage(err.messages),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          fixed: true
        })
      })
    }
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/loader.scss";
</style>
